export default __webpack_public_path__ + "static/trecto-app-mockup-40fa25eec4cc54ba31b82d141b76625a.png";